(function () {
	'use strict';

	var module = angular.module('uwAgenda.users');
	module.factory('UserFilterService', ['$localStorage', '$rootScope', '$filter', 'RoleType', UserFilterServiceFn]);

	// service to handle the storage of the user filters
	function UserFilterServiceFn($localStorage, $rootScope, $filter, RoleType) {
		// data
		var data = {
			captionFilter: null // filter-value for "caption" filter
		};

		// service class
		var service = {
			data: data,
			filterUsers: filterUsers,
			filterUser: filterUser,
			saveRoleFilter: saveRoleFilter,
			loadRoleFilter: loadRoleFilter,
		};

		return service;

		// filters the user list
		function filterUsers(users, rolesForUser) {

			var selectedRoleTypes = loadRoleFilter();

			return users.filter(function (user) {
				return filterUser(user, selectedRoleTypes, rolesForUser);
			});
		}

		// checks if the user is returned by the filters
		function filterUser(user, selectedRoleTypes, rolesForUser) {
			var roleExists = false;
			var captionContains = false;

			// if current user cannot see users for a specific role, hide this user and don't execute the other filters anymore
			var hide = true;
			var x = 0;
			var len = rolesForUser.length;
			for (x; x < len; x++) {
				if (rolesForUser[x].isReadonlyForCurrentUser === false && // if user has other roles too, show him anyway
					((rolesForUser[x].type === RoleType.MainUser.value && user.isMainUser === true) ||
						(rolesForUser[x].type === RoleType.SubuserAdmin.value && user.isSubuserAdmin === true) ||
						(rolesForUser[x].type === RoleType.SubuserRestricted.value && user.isSubuserRestricted === true) ||
						(rolesForUser[x].type === RoleType.RingfoonOperatorAdmin.value && user.isRingfoonOperatorAdmin === true) ||
						(rolesForUser[x].type === RoleType.RingfoonOperatorRestricted.value && user.isRingfoonOperatorRestricted === true) ||
						(rolesForUser[x].type === RoleType.Patient.value && user.isPatient === true) ||
						(rolesForUser[x].type === RoleType.Representative.value && user.isRepresentative === true) ||
						(rolesForUser[x].type === RoleType.RingfoonAdmin.value && user.isRingfoonAdmin === true) ||
						(rolesForUser[x].type === RoleType.Colleague.value && user.isColleague))) {
					hide = false;
					break;
				}
			}

			if (hide) {
				return false;
			}

			// check first if "caption" is found
			if (data.captionFilter !== null) {
				// Check For Caption
				if (user.caption.toLowerCase().indexOf(data.captionFilter.toLowerCase()) !== -1) { captionContains = true; }
			} // if
			else {
				captionContains = true;
			} // else

			// check if roles are selected
			if (typeof selectedRoleTypes !== 'undefined' && selectedRoleTypes !== null && selectedRoleTypes.length > 0) {

				for (var i = 0; i < selectedRoleTypes.length; i++) {
					if ((selectedRoleTypes[i].value === RoleType.MainUser.value && user.isMainUser === true) ||
						(selectedRoleTypes[i].value === RoleType.SubuserAdmin.value && user.isSubuserAdmin === true) ||
						(selectedRoleTypes[i].value === RoleType.SubuserRestricted.value && user.isSubuserRestricted === true) ||
						(selectedRoleTypes[i].value === RoleType.RingfoonOperatorAdmin.value && user.isRingfoonOperatorAdmin === true) ||
						(selectedRoleTypes[i].value === RoleType.RingfoonOperatorRestricted.value && user.isRingfoonOperatorRestricted === true) ||
						(selectedRoleTypes[i].value === RoleType.Patient.value && user.isPatient === true) ||
						(selectedRoleTypes[i].value === RoleType.Representative.value && user.isRepresentative === true) ||
						(selectedRoleTypes[i].value === RoleType.RingfoonAdmin.value && user.isRingfoonAdmin === true) ||
						(selectedRoleTypes[i].value === RoleType.Colleague.value && user.isColleague)) {
						roleExists = true;
					}
				}
			}
			else {// no filter set -> all roles are allowed
				roleExists = true;
			}

			return roleExists && captionContains;
		}

		// save role types
		function saveRoleFilter(selectedRoles) {
			$localStorage.user_role_filter = selectedRoles;
		}

		// load role types
		function loadRoleFilter() {
			return $localStorage.user_role_filter || [];
		}
	}
})();